// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"50591d1f","276":"9952f180","282":"39833130","314":"24efcb69","446":"7049a950","784":"24bd2dfe","996":"52235f57"}[chunkId] + ".chunk.js";
};